export default "__VITE_ASSET__BTR5PRCh__"